import is from '@sindresorhus/is';
import { useContext } from 'react';

import { AmbitionContent } from './AmbitionContent';
import { ApplicationContext } from '../../../../../../../shared/source/context/context';
import {
    useUserAmbitionOptionsQuery,
    useUserAmbitionsQuery,
} from '../../../../../../../shared/source/query-hooks/use-ambition';
import { EditButton } from '../../../../common/buttons/EditButton';
import { editUserAmbitionsUrl } from '../../constants';
import { AddButton } from '../../user-profile/common/ActionButtons';

import type { FunctionComponent } from 'react';

type AmbitionsProps = {
    readonly userId: string;
};

export const Ambitions: FunctionComponent<AmbitionsProps> = ({ userId }) => {
    const { actions } = useContext(ApplicationContext);
    const { data: ambitionOptions } = useUserAmbitionOptionsQuery(userId);
    const canReadAmbitions = ambitionOptions?.canReadAmbitions ?? false;
    const canEditAmbitions = ambitionOptions?.canReadAmbitions ?? false;
    const { data: ambitions } = useUserAmbitionsQuery(userId, canReadAmbitions);

    const actionButtonOnClick = (): void => actions.navigateTo(editUserAmbitionsUrl(userId));
    const actionButton = is.emptyArray(ambitions) ? (
        <AddButton aria-label="Add Ambitions" onClick={actionButtonOnClick} />
    ) : (
        <EditButton aria-label="Edit Ambitions" onClick={actionButtonOnClick} />
    );

    return <AmbitionContent action={canEditAmbitions ? actionButton : null} ambitions={ambitions} />;
};
